<template>
  <v-container grid-list-xl>
    <v-layout row>
      <v-flex xs12 sm12 md12 lg10 offset-lg1 xl8 offset-xl2>
        <h1 class="display-1 mt-3 mb-4 text-xs-center">Contact Us</h1>
        <div class="elevation-2">
          <v-toolbar color="primary" dark tabs>
            <v-tabs
              v-model="contactTabs"
              fixed-tabs
              color="transparent"
              slider-color="white"
            >
              <v-tab v-for="(item, i) in items" :key="i" :to="'#tab-' + i">
                <strong>{{ item.name }}</strong>
              </v-tab>
            </v-tabs>
          </v-toolbar>
          <v-tabs-items v-model="contactTabs">
            <v-tab-item v-for="(item, i) in items" :key="i" :value="'tab-' + i">
              <v-card elevation="15" class="pa-2">
                <v-card-text v-if="item.form === 'BuyerContactForm'">
                  <buyer-contact-form></buyer-contact-form>
                  <agent-disclaimer></agent-disclaimer>
                </v-card-text>
                <v-card-text v-else-if="item.form === 'SellerContactForm'">
                  <seller-contact-form></seller-contact-form>
                  <agent-disclaimer></agent-disclaimer>
                </v-card-text>
                <v-card-text v-else>
                  <general-contact-form></general-contact-form>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import BuyerContactForm from '../components/BuyerContactForm';
import SellerContactForm from '../components/SellerContactForm';
import GeneralContactForm from '../components/GeneralContactForm';
import AgentDisclaimer from '../components/AgentDisclaimer';

export default {
  name: 'Contact',
  metaInfo: {
    title: 'Contact Us',
  },
  components: {
    AgentDisclaimer,
    BuyerContactForm,
    SellerContactForm,
    GeneralContactForm,
  },
  data() {
    return {
      contactTabs: null,
      items: [
        {
          name: 'Seller',
          text: 'Please provide the following data for your property.',
          form: 'SellerContactForm',
        },
        {
          name: 'Buyer',
          text: 'What type of property are you looking for?',
          form: 'BuyerContactForm',
        },
        {
          name: 'Say Hi',
          text: 'How can we help you?',
          form: 'GeneralContactForm',
        },
      ],
    };
  },
};
</script>

<style scoped>
form {
  max-width: 600px;
  margin: 0 auto;
}
</style>
